import { render, staticRenderFns } from "./AddBannerPhotoComponent.vue?vue&type=template&id=dedc2da6&scoped=true"
import script from "./AddBannerPhotoComponent.vue?vue&type=script&lang=js"
export * from "./AddBannerPhotoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedc2da6",
  null
  
)

export default component.exports